import React from 'react'
import { FlexContainer } from '@edulastic/common'
import { VOICE_LANGUAGE_OPTIONS } from '@edulastic/constants/const/languages'
import { TTSFormLabel, VoiceLanguageSelector } from './styled-components'

const VoiceLanguageSelectorComponent = ({
  onChangeVoiceLanguge,
  voiceLanguage,
}) => {
  return (
    <FlexContainer justifyContent="flex-start" alignItems="center">
      <TTSFormLabel margin="0">Set TTS voice in:</TTSFormLabel>

      <VoiceLanguageSelector
        data-cy="tts-language-selector"
        width="100px"
        height="30px"
        margin="0px"
        onSelect={(value) => onChangeVoiceLanguge(value)}
        value={voiceLanguage}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        padding="0px 30px 0px 5px"
        bg="transparent"
        noBorder
      >
        {VOICE_LANGUAGE_OPTIONS.map((language) => (
          <option value={language.value} key={language.value}>
            {language.label}
          </option>
        ))}
      </VoiceLanguageSelector>
    </FlexContainer>
  )
}

export default VoiceLanguageSelectorComponent
